/**
 * @generated SignedSource<<8cc02250a7043fc296c937cc86255088>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VersionHistory_note$data = {
  readonly hasMeetingRecordings: boolean;
  readonly id: string;
  readonly meetingRecordings: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"RecapHistory_meetingRecording">;
  }> | null;
  readonly " $fragmentType": "VersionHistory_note";
};
export type VersionHistory_note$key = {
  readonly " $data"?: VersionHistory_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"VersionHistory_note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VersionHistory_note",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasMeetingRecordings",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecording",
      "kind": "LinkedField",
      "name": "meetingRecordings",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RecapHistory_meetingRecording"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "9f346661b262948df11f8e6d164bcbf2";

export default node;
